import React, { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Router } from '@reach/router';
import AppStateContext from "./context/appStateContext";
import PrivateRoute from './components/privateRoute';

import Assets from './pages/assets';
import Home from './pages/home';
import LogAJob from './pages/logAJob';
import Login from './pages/login';
import PlannedMaintenance from './pages/plannedMaintenance';
import ReactiveMaintenance from './pages/reactiveMaintenance';
import SelectContract from './pages/selectContract';
import MaintenanceSchedule from "./pages/maintenanceSchedule";

import AppStateProvider from './context/appStateProvider';
import JobListProvider from './context/jobListProvider';
import AssetListProvider from './context/assetListProvider';

const App = () => {

  return (
    <AppStateProvider>
      <JobListProvider>
        <AssetListProvider>
          <Router>
            <Login path="/" />
            <PrivateRoute path="app">
              <SelectContract path="selectContract" key='selectContract'/>
              <Home path="home" key='home'/>
              <ReactiveMaintenance path="reactiveMaintenance" key='reactiveMaintenance'/>
              <PlannedMaintenance path="plannedMaintenance" key='plannedMaintenance'/>
              <Assets path="assets" key='assets'/>
              <LogAJob path="logJob" key='logJob'/>
              <MaintenanceSchedule path="maintenanceSchedule" key='maintenanceSchedule'/>
            </PrivateRoute>
          </Router>
        </AssetListProvider>
      </JobListProvider>
    </AppStateProvider>
  );
};

export default App;
